<template>
  <div :class="showcaseHomeHeroContentClasses">
    <div class="header">
      <div class="subtitle showcase-slide-up">
        <div class="text">{{ subtitle }}</div>
        <div class="badge">{{ subtitleBadge }}</div>
      </div>
      <div class="title showcase-slide-up">{{ title }}</div>
    </div>
    <div class="description">
      <div class="container showcase-slide-up">
        {{ description }}
      </div>
    </div>
    <div class="action">
      <div class="section action showcase-slide-up">
        <button
          class="button outline white transparent blur big"
          @click="onClickActionButton"
        >
          {{ actionButtonText }}
        </button>
      </div>
      <div class="section content showcase-slide-right">
        <div class="description">{{ actionContent }}</div>
        <div class="meta">
          <div
            class="item"
            v-for="(item, index) in actionMetaItems"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapMutations } from 'vuex';

export default defineComponent({
  name: 'ShowcaseHomeHeroContent',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      subtitle: '独立开发者之路',
      subtitleBadge: '2K 高清',
      title: '行尽此路，自如表达',
      description:
        '通过连续、完整有效地训练，构建完整的应用设计开发知识系统，独立开发一个带商业模型的应用实例，成为一名独立开发者，可以自如使用代码表达与实现自己的想法。',
      actionButtonText: '验证邀请',
      actionContent: '宁皓原创应用开发系列视频，不加废话。',
      actionMetaItems: ['4段行程', '1536节', '120集', '52小时'],
      initial: true,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    showcaseHomeHeroContentClasses() {
      return ['showcase-home-hero-content'];
    },
  },

  /**
   * 已创建
   */
  created() {
    setTimeout(() => {
      this.initial = false;
    }, 200);
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    onClickActionButton() {
      this.setCurrentStepName('validate');
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/showcase-home-hero-content.css';
</style>
